import { selectShouldShowOverlay } from "app/store/slices/overlay";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLoadToken } from "app/features/authentication/hooks/useLoadToken";
import { useAccessCheck } from "app/features/authentication/hooks/useAccessCheck";

export default function useInitialLoading() {

  const { token, loadToken } = useLoadToken();
  const { accessData, overrideAccessCheck } = useAccessCheck();

  const loading = useSelector(selectShouldShowOverlay);

  const isAuthenticated = !!token;
  useEffect(() => {
    loadToken((hasToken) => {
      if (!hasToken) {
        overrideAccessCheck();
      }
    });
  }, [loadToken]);

  return { isAuthenticated, accessData, loading };
}
